import { usePlatformContext } from "@datassential/platform-ui-lib";
import { ChainSectionsEnum, getSectionData } from "../ChainPage.helpers";

export function useSectionNoAccessMessage(sectionId: ChainSectionsEnum): string {
    const { userInfo: { products } } = usePlatformContext();
    const { noAccess } = getSectionData(sectionId);
    const product = noAccess.appId ? products[noAccess.appId] : undefined;

    return noAccess.getMessage(product?.displayName || product?.name || '');
}
